SetTagView = require './set-tag-view'
PopOver = require 'app/scripts/views/lib/pop-over'

module.exports = class AddTagView extends SetTagView
  onSubmit: (name) ->
    if name
      @model.tagList.create({ name }, wait: true)
      PopOver.popView()
    return

  viewTitleKey: 'add tag'
